// Module
var code = `<div class="js-sltp-trigger" style="{{^triggersVisible}}display:none;{{/}}">
    <terceraLabel text="{{labelText}}" visible="{{triggersVisible}}" />

    <div class="js-sltp-trigger-control">
        <terceraRadioComboItemGroup name="radioComboItemGroup"
                                    visible="{{triggersVisible}}"
                                    isHorisontal="true"
                                    spaceBetweenItems="true" />
    </div>
</div>`;
// Exports
export default code;